{
  "com.wix.ecommerce.catalog.api.v1.ProductChanged": "STORES_PRODUCT_CHANGED",
  "wix.blog.v3.category_created": "wix.blog.category_created",
  "com.wix.ecommerce.cart.abandonment.api.v1.CartAbandonedEvent": "STORES_CART_ABANDONED_CART_WEBHOOK",
  "SitePropertiesUpdated": "SITE_PROPERTIES_UPDATED",
  "wix.events.ticketing.events.TicketDefinitionCreated": "EVENTS_TICKETING_TICKET_DEFINITION_CREATED_WEBHOOK",
  "com.wix.ecommerce.inventory.api.v1.InventoryVariantsChanged": "STORES_INVENTORY_VARIANTS_CHANGED",
  "PaidPlanAutoRenewalCancelled": "APP_SUBSCRIPTION_CANCELLED_WEBHOOK",
  "com.wixpress.formbuilder.api.v1.FormSubmittedEvent": "CRM_FORM_SUBMITTED",
  "wix.blog.v3.post_deleted": "wix.blog.post_deleted",
  "OrderPaid": "STORES_ORDER_PAID_WEBHOOK",
  "wix.events.events.EventReminder": "EVENTS_EVENT_REMINDER",
  "com.wix.ecommerce.catalog.api.v1.CollectionDeleted": "STORES_COLLECTION_DELETED",
  "wix.events.rsvp.events.RsvpCreated": "EVENTS_RSVP_CREATED_WEBHOOK",
  "com.wix.ecommerce.inventory.api.v1.InventoryItemChanged": "STORES_INVENTORY_ITEM_CHANGED",
  "wix.blog.v3.category_updated": "wix.blog.category_updated",
  "wix.events.ticketing.events.OrderUpdated": "EVENTS_TICKETING_ORDER_UPDATED_WEBHOOK",
  "AppInstalled": "APP_PROVISIONED_WEBHOOK",
  "com.wixpress.bookings.resources.core.api.v1.resource.ResourceNotification": "BOOKINGS.RESOURCES.EVENTS",
  "com.wix.ecommerce.catalog.api.v1.CollectionCreated": "STORES_COLLECTION_CREATED",
  "wix.events.ticketing.events.TicketDefinitionDeleted": "EVENTS_TICKETING_TICKET_DEFINITION_DELETED_WEBHOOK",
  "NewMessageReceived": "WIX_CHAT_NEW_MESSAGE",
  "wix.events.events.EventEnded": "EVENTS_EVENT_ENDED_WEBHOOK",
  "SubscriptionOptionsAssignmentChangedForProduct": "wix.stores.v1.subscription_option_assigned",
  "com.wix.ecommerce.catalog.api.v1.ProductCreated": "STORES_PRODUCT_CREATED",
  "PaidPlanPurchased": "APP_SUBSCRIPTION_CREATED_WEBHOOK",
  "wix.events.ticketing.events.OrderInitiated": "EVENTS_TICKETING_ORDER_INITIATED_WEBHOOK",
  "wix.blog.v3.post_created": "wix.blog.post_created",
  "FulfillmentDeleted": "STORES_FULFILLMENT_DELETED",
  "com.wixpress.bookings.services.api.v1.FormNotification": "BOOKINGS.FORMS.EVENTS",
  "com.wix.ecommerce.cart.api.v1.CartCompletedEvent": "STORES_CART_COMPLETED_WEBHOOK",
  "wix.blog.v3.post_unliked": "wix.blog.post_unliked",
  "OrderRefunded": "STORES_ORDER_REFUND_WEBHOOK",
  "wix.events.ticketing.events.ReservationUpdated": "EVENTS_TICKETING_RESERVATION_UPDATED_WEBHOOK",
  "wix.blog.v3.category_deleted": "wix.blog.category_deleted",
  "com.wixpress.bookings.services.api.v1.ServiceNotification": "BOOKINGS.SERVICES.EVENTS",
  "com.wix.ecommerce.catalog.api.v1.CollectionChanged": "STORES_COLLECTION_CHANGED",
  "wix.events.events.EventCreated": "EVENTS_EVENT_CREATED_WEBHOOK",
  "wix.events.ticketing.events.ReservationCreated": "EVENTS_TICKETING_RESERVATION_CREATED_WEBHOOK",
  "wix.events.ticketing.events.OrderDeleted": "EVENTS_TICKETING_ORDER_DELETED_WEBHOOK",
  "wix.events.ticketing.events.OrderConfirmed": "EVENTS_TICKETING_ORDER_CONFIRMED_WEBHOOK",
  "com.wix.ecommerce.catalog.api.v1.ProductDeleted": "STORES_PRODUCT_DELETED",
  "com.wixpress.emailsubscriptions.v1.EmailSubscriptionChanged": "EMAIL_SUBSCRIPTION_CHANGED",
  "com.wix.ecommerce.cart.api.v1.CartCreatedEvent": "STORES_CART_CREATED_WEBHOOK",
  "wix.blog.v3.post_liked": "wix.blog.post_liked",
  "com.wix.ecommerce.orders.api.v2.OrderEvent": "STORES_NEW_ORDER_WEBHOOK",
  "com.wix.bookings.api.v1.BookingNotification": "BOOKINGS.BOOKING.EVENTS",
  "FulfillmentCreated": "STORES_FULFILLMENT_CREATED",
  "wix.events.ticketing.events.TicketDefinitionUpdated": "EVENTS_TICKETING_TICKET_DEFINITION_UPDATED_WEBHOOK",
  "com.wix.payment.api.pay.v3.PaymentEvent": "CASHIER_PAYMENT_EVENT_WEBHOOK",
  "wix.events.events.EventUpdated": "EVENTS_EVENT_UPDATED_WEBHOOK",
  "wix.events.events.EventStarted": "EVENTS_EVENT_STARTED_WEBHOOK",
  "AppRemoved": "APP_REMOVED_WEBHOOK",
  "com.wix.ecommerce.catalog.api.v1.VariantsChanged": "STORES_VARIANTS_CHANGED",
  "com.wix.ecommerce.cart.abandonment.api.v1.CartRecoveredEvent": "STORES_CART_RECOVERED_WEBHOOK",
  "PaidPlanChanged": "APP_SUBSCRIPTION_CHANGED_WEBHOOK",
  "wix.events.rsvp.events.RsvpDeleted": "EVENTS_RSVP_DELETED_WEBHOOK",
  "OneTimePurchasesChanged": "wix.stores.v1.subscription_option_one_time_purcahse_changed",
  "com.wix.bookings.schedules.api.v1.ScheduleNotification": "BOOKINGS.SCHEDULES.EVENTS",
  "OrderCanceled": "STORES_ORDER_CANCEL_WEBHOOK",
  "com.wixpress.bookings.services.api.v1.CategoryNotification": "BOOKINGS.CATEGORIES.EVENTS",
  "wix.events.events.EventCanceled": "EVENTS_EVENT_CANCELED_WEBHOOK",
  "FulfillmentUpdated": "STORES_FULFILLMENT_UPDATED",
  "wix.events.rsvp.events.RsvpUpdated": "EVENTS_RSVP_UPDATED_WEBHOOK",
  "wix.events.events.EventDeleted": "EVENTS_EVENT_DELETED_WEBHOOK",
  "PlanTransferred": "APP_SUBSCRIPTION_TRANSFERRED_WEBHOOK",
  "PlanReactivated": "APP_SUBSCRIPTION_REACTIVATED_WEBHOOK",
  "PlanConvertedToPaid": "APP-SUBSCRIPTION-CONVERTED-TO-PAID-WEBHOOK"
}
